import {BFFClient} from './BFFClient'

const pathName = window.location.pathname
let locale = pathName.split('/')[1]
if (!/[a-z]{2}_[A-Z]{2}/.test(locale)) {
  locale = 'en_US'
}

export const bffClient = new BFFClient(process.env.VUE_APP_ENV === 'local' ? '' : `/${locale}/activity_detail`)
